'use client';

import React, { useEffect, useState } from 'react';
import Icon from '@/components/ui/AppIcon';

function formatLagosTime(date: Date) {
  return new Intl.DateTimeFormat('en-NG', {
    timeZone: 'Africa/Lagos',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  }).format(date);
}

export default function LiveEmergencyStatus({ compact = false }: { compact?: boolean }) {
  const [time, setTime] = useState(() => formatLagosTime(new Date()));

  useEffect(() => {
    const timer = window.setInterval(() => setTime(formatLagosTime(new Date())), 1000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className={`live-status ${compact ? 'live-status-compact' : ''}`}>
      <div className="live-status-icon" aria-hidden="true">
        <span className="pulse-dot" />
      </div>
      <div>
        <div className="live-status-label">Emergency services</div>
        <div className="live-status-value">Open 24/7</div>
      </div>
      {!compact && (
        <div className="live-status-time">
          <Icon name="ClockIcon" size={14} />
          <span>{time} WAT</span>
        </div>
      )}
    </div>
  );
}
